import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { UntilDestroy } from '@ngneat/until-destroy';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import Debug from 'debug';
import * as countries from 'i18n-iso-countries';
import { MixpanelService } from '../../../../../mixpanel/mixpanel.service';
import { MIXPANEL_EVENTS } from '../../../../../mixpanel/mixpanelEvents.enum';
import { environment } from '../../../environments/environment';
import { CountriesMapper } from '../../shared/mappers/countries.mapper';
import { CountriesService } from '../../shared/services/countries.service';
import { BasePageComponent } from '../base.page';
import { Paths } from './../../enums/paths.enum';
import { localizationKeys } from './../../utils/localizationKeys';

const debug = Debug('aumico:saas:SignupPage');

@UntilDestroy()
@Component({
    selector: 'app-page-signup',
    templateUrl: './signup.page.html',
    styleUrls: ['./signup.page.scss'],
})
export class SignupPage extends BasePageComponent implements OnInit {
    defaultLanguage = environment.defaultLanguage;
    loginQuestionTextKey = localizationKeys.aumico_reports_registration_bottom_question;
    loginQuestionButtonTextKey = localizationKeys.aumico_reports_registration_bottom_button_of_question_login;
    isPersonalInformationCurrentStep = false;
    countries: INameId[];

    // this handler is passed so its this is the action not the class,
    // making it an arrow function is better to maintain the this inside it's creation scope (the class's constructor)
    readonly questionButtonClickedAction = (): void => {
        this.navigateToLoginPage();
    };

    constructor(
        injector: Injector,
        protected override router: Router,
        private readonly mixpanel: MixpanelService,
        private gtmService: GoogleTagManagerService,
        private readonly countriesMapper: CountriesMapper,
        private readonly countriesService: CountriesService,
    ) {
        super(injector);
        this.prepareCountries();
    }

    override ngOnInit(): void {
        this.gtmService.addGtmToDom();
        super.ngOnInit();
    }

    onSignUpSuccess(email: string): void {
        this.mixpanel.track(MIXPANEL_EVENTS.SIGN_UP_BUTTON);
        this.navigateToConfirmationPage(email);
    }

    onStepsChange(isPersonalInfromationStep: boolean): void {
        this.isPersonalInformationCurrentStep = isPersonalInfromationStep;
    }

    private navigateToLoginPage(): void {
        const currentLanguage = this.getCurrentLanguageWithFallBack();
        this.router.navigate([`/${currentLanguage}`, Paths.AUTH, Paths.LOGIN]);
    }

    private navigateToConfirmationPage(email: string): void {
        const currentLanguage = this.getCurrentLanguageWithFallBack();
        this.router.navigate([`/${currentLanguage}`, Paths.AUTH, Paths.CONFIRM_ACCOUNT], {
            queryParams: { email },
        });
    }

    private prepareCountries(): void {
        const currentLanguage = this.getCurrentLanguageWithFallBack();
        const retrievedCountriesByUSerLanguage: countries.LocalizedCountryNames<{ select: 'official' }> =
            this.countriesService.getCountriesByLanguage(currentLanguage);
        this.countries = this.countriesMapper.mapCountries(retrievedCountriesByUSerLanguage);
    }
}
